
import ShellApi from 'a365-shell-api';


export const connectionAnchorIds = {
    IRTab: 'connection-irtab',
    LinkedServiceTab: 'connnection-linkedservicetab'
};

export const connectionTourSteps: ShellApi.tour.IStepOption[] = [
    {
        anchorId: connectionAnchorIds.LinkedServiceTab,
        title: stringResources.Tour_Connection_LinkedService_Title,
        content: stringResources.Tour_Connection_LinkedService
    }, {
        anchorId: connectionAnchorIds.IRTab,
        title: stringResources.Tour_Connection_IR_Title,
        content: stringResources.Tour_Connection_IR
    }
];
